import BeCashBackOffice from "../components/BeCashBackOffice";
import useBeCash from "../hook/useBeCash";

const BeCashBackOfficePage = () => {
    const becash = useBeCash();

    return (
        <BeCashBackOffice {...becash} />
    )
}

export default BeCashBackOfficePage;